var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.responded
        ? _c("div", { staticClass: "sections" }, [
            _c(
              "section",
              [
                _c("h3", [_vm._v("Ergebnis:")]),
                _vm._v(" "),
                _c("RadioGroup", {
                  attrs: { options: _vm.tookPlaceOptions, stacked: "" },
                  model: {
                    value: _vm.tookPlace,
                    callback: function($$v) {
                      _vm.tookPlace = $$v
                    },
                    expression: "tookPlace"
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.appointmentTookPlace
        ? _c("TookPlace", {
            staticClass: "mt-5",
            attrs: { message: _vm.message },
            on: {
              processed: function($event) {
                return _vm.$emit("processed")
              },
              responded: function($event) {
                return _vm.$emit("processed")
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.appointmentDidNotTakePlace
        ? _c("DidNotTakePlace", {
            staticClass: "mt-5",
            attrs: { message: _vm.message },
            on: {
              processed: function($event) {
                return _vm.$emit("processed")
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }